import type React from 'react';
import { InputField, type InputFieldProps } from '../InputField';

export const DestinationInputField = ({
  children,
  error,
}: {
  children: React.ReactNode;
} & Pick<InputFieldProps, 'error'>) => (
  <InputField
    label="Replace everywhere with"
    name="destinationImage"
    error={error}
  >
    {children}
  </InputField>
);
